import { MemberState } from './registration-model';
import { normalizeQuestionaries } from '../../../shared/utils/member-helpers';

export interface RegistrationSelection {
  plan: string; payment: string; sex: { id: number } | null; nationality: { id: number } | null;
  relationship: { id: number } | null; questionaries: unknown;
  visitPlan: string; visitDatetime: string; visitNote: string; cardNameValid: string;
}
/** A single confirmation snapshot: never writes into the live NgForm while awaiting an API. */
export function confirmationInput(source: MemberState, selected: RegistrationSelection): MemberState {
  const member: MemberState = JSON.parse(JSON.stringify(source));
  member.isSendKey = 1; member.isEnableWebLogin = 1; member.isReceiveAd = 1;
  const tmp = member.tmp;
  if (!member.zip && tmp.zip1 && tmp.zip2) member.zip = `${tmp.zip1}-${tmp.zip2}`;
  if (selected.plan) {
    tmp.planString = selected.plan; tmp.plan = selected.plan.split(','); member.studioPlanId = Number(tmp.plan[0]);
  }
  if (tmp.birth_year && tmp.birth_month && tmp.birth_date) member.birthday = `${tmp.birth_year}-${String(tmp.birth_month).padStart(2, '0')}-${String(tmp.birth_date).padStart(2, '0')}`;
  if (selected.sex) { tmp.sex = selected.sex; member.sex = selected.sex.id; }
  if (selected.nationality) { tmp.nationality = selected.nationality; member.isJapanese = selected.nationality.id; }
  if (tmp.tel1 && tmp.tel2 && tmp.tel3) member.phone = `${tmp.tel1}-${tmp.tel2}-${tmp.tel3}`;
  if (selected.payment) member.payment.paymentMethod = selected.payment;
  if (selected.relationship) { tmp.relationship = selected.relationship; member.emRelationship = selected.relationship.id; }
  if (tmp.emTel1 && tmp.emTel2 && tmp.emTel3) member.emPhone = `${tmp.emTel1}-${tmp.emTel2}-${tmp.emTel3}`;
  if (selected.questionaries) {
    tmp.questionarys = JSON.parse(JSON.stringify(selected.questionaries)); normalizeQuestionaries(tmp.questionarys);
  }
  tmp.selectVisitPlan = selected.visitPlan || undefined; tmp.visitDatetime = selected.visitDatetime || undefined;
  tmp.visitNote = selected.visitNote || undefined; tmp.isEntry = member.isEntry; tmp.isOKCcName = selected.cardNameValid;
  return member;
}
